<template>
  <!-- Side Menu -->
  <div class="column is-4-tablet is-desktop-3 is-2-fullhd side-menu">
    <div class="flex justify-between align-middle py-4">
      <span class="uppercase pl-5">
        {{ userProfile.name }} {{ userProfile.lastName }}
      </span>
      <span
        class="mobile-handle"
        @click="toggleMenu"
      >
        <b-icon
          v-if="isMenuOpen"
          icon="chevron-down"
          size="is-medium"
        />
        <b-icon
          v-else
          icon="chevron-up"
          size="is-medium"
        />
      </span>
    </div>
    <ul
      class="side-menu-items"
      :class="{'open': isMenuOpen}"
    >
      <!-- Professional Profile -->
      <li
        v-if="userProfile.userType=='professional'"
        class="side-menu-item my-profile"
        :class="{'is-active': activeDashboardSection == 'professionalProfileSection'}"
        @click="setActiveDashboardSection('professionalProfileSection')"
      >
        <b-icon
          icon="account-circle"
          size="is-medium"
        />
        <span>Meu Perfil</span>
      </li>

      <!-- User Profile -->
      <li
        v-if="userProfile.userType=='patient'"
        class="side-menu-item my-profile"
        :class="{'is-active': activeDashboardSection == 'userProfileSection'}"
        @click="setActiveDashboardSection('userProfileSection')"
      >
        <b-icon
          icon="account-circle"
          size="is-medium"
        />
        <span>Meu Perfil</span>
      </li>

      <!-- Subscription -->
      <li
        v-if="userProfile.userType=='professional'"
        class="side-menu-item my-plan"
        :class="{'is-active': activeDashboardSection == 'subscriptionSection'}"
        @click="setActiveDashboardSection('subscriptionSection')"
      >
        <b-icon
          icon="playlist-check"
          size="is-medium"
        />
        <span>Meu Plano </span>
      </li>

      <!-- Posts -->
      <li
        v-if="userProfile.userType=='professional'"
        class="side-menu-item content-submission"
        :class="{'is-active': activeDashboardSection == 'postSection'}"
        @click="setActiveDashboardSection('postSection')"
      >
        <b-icon
          icon="content-copy"
          size="is-medium"
        />
        <span>Blog</span>
      </li>

      <!-- Users -->
      <li
        v-if="isAdmin"
        class="side-menu-item user-management"
        :class="{'is-active': activeDashboardSection == 'users'}"
        @click="setActiveDashboardSection('users')"
      >
        <b-icon
          icon="account-multiple"
          size="is-medium"
        />
        <span>Usuários</span>
      </li>

      <!-- Moderation -->
      <li
        v-if="isAdmin"
        class="side-menu-item posts-moderation"
        :class="{'is-active': activeDashboardSection == 'moderation'}"
        @click="setActiveDashboardSection('moderation')"
      >
        <b-icon
          icon="shield-edit"
          size="is-medium"
        />
        <span>Moderação do Blog</span>
      </li>
      <!-- Favorites -->
      <li
        class="side-menu-item favorites"
        :class="{'is-active': activeDashboardSection == 'favorites'}"
        @click="setActiveDashboardSection('favorites')"
      >
        <b-icon
          icon="star"
          size="is-medium"
        />
        <span>Favoritos</span>
      </li>

      <!-- Plans -->
      <li
        v-if="isAdmin"
        class="side-menu-item plans"
        :class="{'is-active': activeDashboardSection == 'plans'}"
        @click="setActiveDashboardSection('plans')"
      >
        <b-icon
          icon="currency-usd"
          size="is-medium"
        />
        <span>Planos premium</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      isMenuOpen: true
    }
  },
  computed: {
    ...mapState(['userProfile', 'activeDashboardSection', 'isAdmin', 'currentUserFavorites'])
  },
  methods: {
    ...mapActions(['setActiveDashboardSection']),
    toggleMenu () {
      this.isMenuOpen = !this.isMenuOpen
    }
  },
  created () {
    this.$store.dispatch('checkAdminStatus')
  }
}
</script>

<style scoped>
.side-menu-items {
  display: none;
}
.side-menu-items.open {
  display: block;
}

@media only screen and (min-width: 769px) {
  .mobile-handle {
    display: none;
  }

  .side-menu-items, .side-menu-items.open {
    display: block;
  }
}
</style>
